(function() {
  function enhance(container) {
    if (!container || container.dataset.descEnhanced === "true") return;

    const children = Array.from(container.children);
    const firstP = children.find(el => el.tagName === "P");
    if (!firstP) {
      container.dataset.descEnhanced = "true";
      return;
    }

    const extraWrapper = document.createElement("div");
    extraWrapper.setAttribute("data-role", "extra-content");
    extraWrapper.style.display = "none";

    let node = firstP.nextSibling;
    while (node) {
      const next = node.nextSibling;
      extraWrapper.appendChild(node);
      node = next;
    }

    if (!extraWrapper.childNodes.length) {
      container.dataset.descEnhanced = "true";
      return;
    }

    container.appendChild(extraWrapper);

    // inserire la cta scheda tectnica dentro la description
    const schedaTecnica = document.getElementById('scheda-tecnica');
    if (schedaTecnica) {
      extraWrapper.appendChild(schedaTecnica);
      schedaTecnica.style.display = "inline-block";
      schedaTecnica.style.marginTop = "10px";
      schedaTecnica.style.marginBottom = "40px";
    }
    //////

    const btn = document.createElement("button");
    btn.type = "button";
    btn.setAttribute("aria-expanded", "false");
    btn.style.marginTop = "0";
    btn.style.background = "none";
    btn.style.border = "none";
    btn.style.color = "#0fa9f0";
    btn.style.fontWeight = "700";
    btn.style.cursor = "pointer";
    btn.style.padding = "0";
    btn.style.display = "inline-flex";
    btn.style.alignItems = "center";
    btn.style.gap = "6px";

    const textSpan = document.createElement("span");
    textSpan.textContent = "Mostra di più";

    const arrowSpan = document.createElement("span");
    arrowSpan.style.display = "inline-block";
    arrowSpan.style.transition = "transform 0.2s ease";

    // SVG interno
    arrowSpan.innerHTML = `
      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6" width="10" height="6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
      </svg>
    `;

    btn.appendChild(textSpan);
    btn.appendChild(arrowSpan);

    btn.addEventListener("click", function() {
      const open = extraWrapper.style.display !== "none";
      extraWrapper.style.display = open ? "none" : "block";
      textSpan.textContent = open ? "Mostra di più" : "Mostra di meno";
      arrowSpan.style.transform = open ? "rotate(0deg)" : "rotate(180deg)";
      btn.setAttribute("aria-expanded", String(!open));
    });

    container.appendChild(btn);
    container.dataset.descEnhanced = "true";
  }

  function enhanceAll(root = document) {
    root.querySelectorAll(".product__description").forEach(enhance);
  }

  enhanceAll();

  document.addEventListener("shopify:section:load", (e) => {
    enhanceAll(e.target || document);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType !== 1) return;
        if (node.matches?.(".product__description")) {
          enhance(node);
        } else {
          node.querySelectorAll?.(".product__description").forEach(enhance);
        }
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });


})();
